module.exports = __webpack_public_path__ + "img/report_banner4.2e5e514d.png";